const threePL = {
  activeCustomer: {},
  activeCustomerName: {},
  toggleParamountCustomerFlag: true,
}

const ThreePLReducer = function (state = threePL, action) {
  switch (action.type) {
    case 'SET_3PL_ACTIVE_CUSTOMER': {
      return {
        ...state,
        activeCustomer: action.value,
      }
    }
    case 'RESET_3PL_ACTIVE_CUSTOMER': {
      return {
        ...state,
        activeCustomer: {},
      }
    }
    case 'UPDATE_3PL_ACTIVE_CUSTOMER_NAME': {
      return {
        ...state,
        activeCustomerName: action.value,
      }
    }
    case 'TOGGLE_PARAMOUNT_CUSTOMER': {
      return {
        ...state,
        toggleParamountCustomerFlag: action.value,
      }
    }
    default: {
      return state
    }
  }
}

export default ThreePLReducer
